
/**
 * Turns { name: 'id' }, { id: value } into { name: value }
 * @param { newKey: key } map
 * @param { key: value } values
 * @returns { newKey: value }
 */
import * as Routes from '../../app/constants/routes';

const COMPANY_LOGIN_INDEX = 0;
const OPERATOR_LOGIN_INDEX = 1;
const PASSWORD_INDEX = 2;
const SHOULD_REMEMBER_INDEX = 3;

export const composeByIdMap = (map, values) => Object.keys(map)
  .reduce((acc, name) => {
    acc[name] = values[map[name]];
    return acc;
  }, {});

export const parseAutoLogin = params => {
  const index = params.indexOf('=');
  if (index === '-1') {
    return null;
  }

  const dataString = params.slice(index + 1, params.length);
  const data = dataString.split('|');

  return {
    companyLogin: data[COMPANY_LOGIN_INDEX],
    operatorLogin: data[OPERATOR_LOGIN_INDEX],
    operatorPasswordHash: data[PASSWORD_INDEX],
    shouldRemember: data[SHOULD_REMEMBER_INDEX] === 'true',
  }
};

export const checkPageToView = () => {
  const path = window.location.pathname;
  const { HOME, LOGIN, PASSWORD_RECOVERY, AUTO_LOGIN } = Routes;
  if (path !== HOME && path !== LOGIN && path !== PASSWORD_RECOVERY && path !== AUTO_LOGIN) {
    window.location.pathname = Routes.LOGIN;
  }
}

export const transformUnicode10to16 = text => {
  const matches = text.match(/&#([\1-9\S]){4};/g);
  if (!matches) {
    return text;
  }

  matches.forEach(match => {
    text = text.replace(match, String.fromCharCode(match.replace(/[&#;]/g, '')))
  });

  return text;
}

// https://operator.providesupport.com
// /?operator-auto-login-info=kterentiev|operator1|2d3b2e172777d6f5c40b3b8ad9183fbe1ead2c4|false
